/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Noaccess2Inputs */

const en_usermanagement_permissions_noaccess2 = /** @type {(inputs: Usermanagement_Permissions_Noaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access`)
};

/**
* | output |
* | --- |
* | "No access" |
*
* @param {Usermanagement_Permissions_Noaccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_noaccess2 = /** @type {((inputs?: Usermanagement_Permissions_Noaccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Noaccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_noaccess2(inputs)
});
export { usermanagement_permissions_noaccess2 as "userManagement_permissions_noAccess" }